import React from "react"

const BankIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M13.7578 24.4766V11.5156"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask
        id="mask0_4781_6499"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="28"
        height="28"
      >
        <path d="M2 2H30V30H2V2Z" fill="white" />
      </mask>
      <g mask="url(#mask0_4781_6499)">
        <path
          d="M20.5391 28.9062H3.09375V24.5312H18.1328V11.5156"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.00781 11.5156V24.5312"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M9.38281 24.4766V11.5156"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask
        id="mask1_4781_6499"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="28"
        height="28"
      >
        <path d="M2 2H30V30H2V2Z" fill="white" />
      </mask>
      <g mask="url(#mask1_4781_6499)">
        <path
          d="M15.9727 3.09375L3.09375 7.35937V11.4609H28.9062V7.35937L15.9727 3.09375Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8983 27.1016V28.9062"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8979 11.4629V15.3457"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.8516 7.68945C14.8516 7.08538 15.3412 6.5957 15.9453 6.5957C16.5494 6.5957 17.0391 7.08538 17.0391 7.68945C17.0391 8.29353 16.5494 8.7832 15.9453 8.7832C15.3412 8.7832 14.8516 8.29353 14.8516 7.68945Z"
          fill="white"
        />
        <path
          d="M23.3057 25.3516C23.7549 26.3509 24.7591 27.0469 25.9258 27.0469C27.5114 27.0469 28.7969 25.7614 28.7969 24.1758C28.7969 22.5901 27.5114 21.3047 25.9258 21.3047C24.3401 21.3047 23.0547 20.0193 23.0547 18.4336C23.0547 16.8479 24.3401 15.5625 25.9258 15.5625C27.1136 15.5625 28.1331 16.2839 28.5698 17.3125"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export default BankIcon
